import { ChangeDetectorRef, Component, Inject, Injector, OnInit, ViewChild, ViewChildren, QueryList, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BlueprintService } from '@vex/http-service/blueprint.service';
import { InventoryService } from '@vex/http-service/inventory.service';
import { Icons } from '@vex/icons/icons';
import { HelperService } from '@vex/services/helper.service';
import { BluePrintStateService } from '@vex/constants/bluepirnt-state';
import { MatStepper } from '@angular/material/stepper';
import {
  MonacoEditorConstructionOptions,
  MonacoStandaloneCodeEditor
} from '@materia-ui/ngx-monaco-editor';
import { InventoryCatalog, InventoryType } from '@vex/model/blueprint-list';
import { CloudConnectStateService } from '@vex/constants/cloud-connect-state';
import { InventoryTreeComponent } from '@vex/components/inventory-tree/inventory-tree/inventory-tree.component';
import { MultipleSelectionSelectAllComponent } from '@vex/components/vex-selection/multiple-selection-select-all/multiple-selection-select-all.component';
import { debounceTime, distinctUntilChanged, filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import { AppCompService } from '@vex/http-service/app-component.service';
import { DataURLCommonService } from '@vex/services/data-url-common.service';
import { AttributeTypeService } from '@vex/http-service/attribute-type.service';
import { AdvanceDataTypeService } from '@vex/services/advance-data-type.service';
import { DependencyMapService } from '@vex/http-service/dependency-map.service';
import { ActivatedRoute } from '@angular/router';
import { AssociatedConfigurationComparisonService } from '@vex/services/associated-configuration-comparison.service';
import { MonacoEditorService } from '@vex/services/monaco-editor-service.service';
import { CredentialReferenceService } from '@vex/services/credential-reference.service';

@Component({
  selector: 'vex-inventory-compare',
  templateUrl: './inventory-compare.component.html',
  styleUrls: ['./inventory-compare.component.scss']
})
export class InventoryCompareComponent extends Icons implements OnInit,OnDestroy {
  dialog_title: string = 'Instances';
  state: any = {};
  editorOptions: MonacoEditorConstructionOptions = {
    theme: 'vs-dark',
    language: 'typescript',
    roundedSelection: true,
    autoIndent: 'full',
    readOnly: true,
    showDeprecated: false
  };
  loadEditor: boolean = true;
  @ViewChild('stepper', { static: false }) stepper: MatStepper;
  compareData: any = {};
  types = InventoryType;
  cloudName: string = '';
  CloudColor: any = {};
  selectedIndex: number = 0;
  SourceInventory: any = {};
  SourceSummary: any[] = [];
  TotalResourceSource: number = 0;
  TotalResourceTarget: number = 0;
  TargetInventory: any = {};
  TargetSummary: any[] = [];
  configurationLoader: boolean = false;
  configurationCounter = 0;
  summaryLoader: boolean = true;
  summaryCounter = 0;
  isActiveConfiguartionTab: boolean = false;
  isShowTreeView: boolean = false;
  selectedResource: string = '';
  resources: any[] = [];
  searchResource: string = '';
  searchResources$ = new Subject<string>();
  filterAttribute: any = {
    IsMandatory: false,
    DisplayName: 'Resources',
    loader: false,
    Name: 'ResourceIds'
  };
  form: FormGroup;
  counter: number = 0;
  @ViewChildren(InventoryTreeComponent) inventoryTreeComponents: QueryList<InventoryTreeComponent>;
  @ViewChild('MultipleSelectionSelectAllComponent', { static: false }) multiAll: MultipleSelectionSelectAllComponent;
  isEditorShowSeprate: boolean = false;
  embeddedMode: boolean = false;
  isTemplate: boolean = false;
  associatedConfigurationComparisons: any[] = [];
  associatedConfigurationLoading: boolean = false;
  associatedConfigurationLoaded: boolean = false;
  associatedInventoryComparisonComponent: any = InventoryCompareComponent;
  associatedInventoryComparisonInjectors: { [comparisonKey: string]: Injector } = {};
  private associatedConfigurationRequested: boolean = false;
   private destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<InventoryCompareComponent>,
    public cloudConnectStateService: CloudConnectStateService,
    private inventoryService: InventoryService,
    private blueprintService: BlueprintService,
    private stateService: BluePrintStateService,
    public helperService: HelperService,
    private appService: AppCompService,
    private formBuilder: FormBuilder,
    private dataUrlCommonService: DataURLCommonService,
    private attributeTypeService: AttributeTypeService,
    private advanceDataTypeService: AdvanceDataTypeService,
    private dependencyMapService: DependencyMapService,
    private route: ActivatedRoute,
    private associatedConfigurationComparisonService: AssociatedConfigurationComparisonService,
    private cd: ChangeDetectorRef,
    private injector: Injector,
    private monacoEditorService: MonacoEditorService,
    private credentialReferenceService: CredentialReferenceService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    super();
    this.getAllCloud();
    this.CloudColor = this.cloudConnectStateService.getProviderStyle();
    if(this.data.title) {
      this.dialog_title = this.data.title;
    }
    this.embeddedMode = this.data?.embeddedMode || false;
  }

  usesAccountCredential(inventory, cloudName) {
    return this.credentialReferenceService.usesAccount(inventory, cloudName);
  }

  getDefaultAudit(data) {
    return {
      UpdatedDate: data.UpdatedDate,
      CreatedDate: data.CreatedDate,
      UpdatedBy: data.UpdatedBy,
      CreatedBy: data.CreatedBy,
      LastCommitMessage: data.LastCommitMessage,
      State: data.State || 0,
    }
  }

  getAllCloud(){
    this.dependencyMapService.getDependencyMapsCollectionEntriesForSelect().pipe(takeUntil(this.destroy$)).subscribe((response) => {
      this.cloudConnectStateService.setCloudData(response);
      this.requestFirstCompleted = ++this.counter;
    },(error)=>{
        this.requestFirstCompleted = ++this.counter;
    });
  }

  set requestFirstCompleted(val: number) {
      if (val == 1) {
        this.getInventoryDetail(this.data.SourceInventoryId, 'Source');
        if(this.data.TargetInventory) {
          this.bindInventory('Target', this.data.TargetInventory);
        } else {
          this.getInventoryDetail(this.data.TargetInventoryId, 'Target');
        }
        this.onSearchResources();
      }
  }

  onToggleChange(change) {
    this.isEditorShowSeprate = false;
    if (change.checked) this.isEditorShowSeprate = true;
  }

  set requestCompletedSummary(val: number) {
    if (val === 4) {
      let sourceRoute = this.SourceSummary.find(x=> x.Name == 'Route Table');
      let targetRoute = this.TargetSummary.find(x=> x.Name == 'Route Table');
      if(sourceRoute && targetRoute) {
        if(sourceRoute.SubCount != targetRoute.SubCount) {
          sourceRoute.IsDifference = true;
          targetRoute.IsDifference = true;
        }
      }
      let sourceNSG = this.SourceSummary.find(x=> x.Name == 'NSG');
      let targetNSG = this.TargetSummary.find(x=> x.Name == 'NSG');
      if(sourceNSG && targetNSG) {
        if(sourceNSG.SubCount != targetNSG.SubCount) {
          sourceNSG.IsDifference = true;
          targetNSG.IsDifference = true;
        }
      }
      this.summaryLoader = false;
    }
  }

  set requestCompletedConfiguration(val: number) {
    if (val === 4) {
      this.configurationLoader = true;
    }
  }

  close() {
    this.dialogRef.close();
  }

  getHeight(height: number = 0) {
    const height_inner = (window.innerHeight - height).toString();
    return height_inner + 'px';
  }

  filterTrees(values) {
    if(this.inventoryTreeComponents){
      let trees = this.inventoryTreeComponents.toArray();
      for(let i = 0; i < trees.length; i++) {
        trees[i].filterResource = values;
        trees[i].filter();
      }
    }
  }

  onClickResource(resourceId: string = '', resourceName: string = '') {
    if (this.embeddedMode) {
      return;
    }

    this.selectedIndex = 1;
    this.selectedResource = resourceName;
    this.form.get('ResourceIds').setValue([resourceId]);
    this.form.updateValueAndValidity();
    if(this.multiAll) {
      this.multiAll.formMultiCtrl.setValue([resourceId]);
      this.multiAll.mySelections = [resourceId];
      this.multiAll.oldValue = [resourceId];
    }
    let trees = this.inventoryTreeComponents?.toArray();
    if (trees.length > 0) {
      this.filterTrees([resourceId]);
    } else {
      setTimeout(() => {
        this.filterTrees([resourceId]);
      }, 100);
    }
  }

  summaryHeight:string = "";
  treeHeight:string = "";
  associatedConfigurationHeight:string = "";
  configurationHeight:string = "";
  ngOnInit(): void {
    this.summaryHeight = this.getHeight(230);
    this.treeHeight = this.getHeight(350);
    this.associatedConfigurationHeight = this.getHeight(230);
    this.configurationHeight = this.getHeight(230);
    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(params => {
      this.isTemplate = params['type'] === 'template';
    });
    this.form = this.formBuilder.group(
      {
        ResourceIds: [[]],
      }
    );
  }

  trackByListId(index: number, list: any) {
    return list.Id || list.Name;
  }

   ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.monacoEditorService.destroyEditors(this.editors);
    this.editors = [];
  }

  onSearchResources() {
    this.searchResources$
    .pipe(distinctUntilChanged(), debounceTime(800),takeUntil(this.destroy$))
    .subscribe(() => {
      if(this.inventoryTreeComponents){
        let trees = this.inventoryTreeComponents.toArray();
        for(let i = 0; i < trees.length; i++) {
          trees[i].searchResource = this.searchResource;
          trees[i].filter();
        }
        this.onSearchResources();
      }
    });
  }

  onReset() {
    this.searchResource = '';
    this.form.get('ResourceIds').setValue([]);
    this.form.updateValueAndValidity();
    if(this.multiAll) {
      this.multiAll.formMultiCtrl.setValue([]);
      this.multiAll.mySelections = [];
      this.multiAll.oldValue = [];
    }
    if(this.inventoryTreeComponents){
      let trees = this.inventoryTreeComponents.toArray();
      for(let i = 0; i < trees.length; i++) {
        trees[i].searchResource = '';
        trees[i].filterResource = [];
        trees[i].filter();
      }
    }
  }

  getTerraformCode(inventoryId, type: string = 'Source') {
    this.inventoryService.getTerraformCodeById(inventoryId, true).pipe(takeUntil(this.destroy$)).subscribe(
      (res) => {
        this.compareData[type + 'Code'] = res ? res.result : '';
        this.requestCompletedConfiguration = ++this.configurationCounter;
      },
      () => {
        this.requestCompletedConfiguration = ++this.configurationCounter;
      }
    );
  }

  getTerraformCodeByObj(data, type: string = 'Source') {
    this.blueprintService.getTerraformCode({inventory: data}).pipe(takeUntil(this.destroy$)).subscribe((response: any) => {
      this.compareData[type + 'Code'] = response ? response.result : '';
      this.requestCompletedConfiguration = ++this.configurationCounter;
    });
  }

  getInventoryDetail(inventoryId: string, type: string = 'Source') {
    this.inventoryService.getInventoryById(inventoryId).pipe(takeUntil(this.destroy$)).subscribe(
      (inventory) => {
        this.bindInventory(type, inventory);
      },
      () => {
        this.dialogRef.close();
      }
    );
  }

  bindInventory(type, inventory) {
    this[type + 'Inventory'] = inventory;
    this.compareData[type + 'Name'] = inventory.Name;
    this.compareData[type + 'Version'] = inventory.Version;
    this.compareData[type + 'UpdatedDate'] = inventory.UpdatedDate;
    this.compareData[type + 'CreatedDate'] = inventory.CreatedDate;
    this[type + 'Inventory']['CloudName'] = inventory.Blueprint.BlueprintContainers[0].Name;
    inventory.Blueprint.BlueprintContainers.forEach((d) => this.getContainer(d, type));
    this.getState(inventory.State, type);
    this.getResource([inventory.Blueprint.BlueprintContainers[0].DependencyMapId], type);
    this.getAttributeTypes(inventory.Blueprint.BlueprintContainers[0].DependencyMapId);
    this.requestCompletedSummary = ++this.summaryCounter;
    this.requestCompletedConfiguration = ++this.configurationCounter;
    this.loadAssociatedConfigurationComparison();
  }

  loadAssociatedConfigurationComparison() {
    if (this.embeddedMode || this.associatedConfigurationRequested) {
      return;
    }

    if (!this.SourceInventory?.Blueprint || !this.TargetInventory?.Blueprint) {
      return;
    }

    this.associatedConfigurationRequested = true;
    this.associatedConfigurationLoading = true;
    this.associatedConfigurationLoaded = false;
    this.refreshAssociatedConfigurationView();

    this.associatedConfigurationComparisonService
      .loadFromBlueprints(this.SourceInventory.Blueprint, this.TargetInventory.Blueprint).pipe(takeUntil(this.destroy$))
      .subscribe((comparisons) => {
        this.associatedConfigurationComparisons = comparisons;
        this.associatedConfigurationLoading = false;
        this.associatedConfigurationLoaded = true;
        this.refreshAssociatedConfigurationView();
      }, () => {
        this.associatedConfigurationComparisons = [];
        this.associatedConfigurationLoading = false;
        this.associatedConfigurationLoaded = true;
        this.refreshAssociatedConfigurationView();
      });
  }

  refreshAssociatedConfigurationView() {
    this.cd.markForCheck();
    setTimeout(() => this.cd.detectChanges());
  }

  showAssociatedConfigurationTab() {
    return !this.embeddedMode && (this.associatedConfigurationLoading || this.hasAssociatedConfigurationComparisons());
  }

  hasAssociatedConfigurationComparisons() {
    return this.associatedConfigurationComparisons.length > 0;
  }

  getAssociatedInventoryId(configuration: any) {
    return configuration?.ParsedInventoryId;
  }

  canCompareAssociatedInventories(comparison: any) {
    return this.getAssociatedInventoryId(comparison?.source) && this.getAssociatedInventoryId(comparison?.target);
  }

  getAssociatedInventoryComparisonInjector(comparison: any) {
    const sourceInventoryId = this.getAssociatedInventoryId(comparison?.source);
    const targetInventoryId = this.getAssociatedInventoryId(comparison?.target);
    const key = [sourceInventoryId, targetInventoryId].join('|');
    if (!this.associatedInventoryComparisonInjectors[key]) {
      this.associatedInventoryComparisonInjectors[key] = Injector.create({
        providers: [
          {
            provide: MAT_DIALOG_DATA,
            useValue: {
              SourceInventoryId: sourceInventoryId,
              TargetInventoryId: targetInventoryId,
              title: 'Associated Configuration',
              embeddedMode: true
            }
          }
        ],
        parent: this.injector
      });
    }

    return this.associatedInventoryComparisonInjectors[key];
  }

  getAttributeTypes(dependencyMapId) {
    this.attributeTypeService.getAllAtributes().pipe(takeUntil(this.destroy$))
    .subscribe((response) => {
        this.advanceDataTypeService.attributeTypes = response;
    });
  }

  getContainer(container: any, type: string = 'Source') {
    container['IsContainer'] = true;
    container['ContainerId'] = container.Id;
    container.BlueprintCollections.forEach((f) => {
      this.getCollections(f, type);
    });
    this[type + 'Summary'].sort((a, b) => a.Name.toLowerCase() > b.Name.toLowerCase() ? 1 : -1);
    this[type + 'Summary'].forEach(element => {
      this['TotalResource'+type] += element.Count;
    });
  }

  getCollections(collection: any, type: string = 'Source') {
    if (
      collection.BlueprintCollectionAttributes &&
      collection.BlueprintCollectionAttributes.length > 0
    ) {
      if (this.resources.findIndex((x) => x.Value == collection.CollectionEntryId) == -1) {
        this.resources.push({
            Label: collection.CollectionName,
            Value: collection.CollectionEntryId
        });
      }
      let entry = this[type + 'Summary'].filter((d) => d.Id === collection.CollectionEntryId)[0];
      if (entry) {
        entry.Count += 1;
      } else {
        this[type + 'Summary'].push({
          Id: collection.CollectionEntryId,
          Count: 1,
          SubCount: 0,
          Name: collection.CollectionName
        });
      }
      if(collection.CollectionName == 'Route Table') {
        let routes = this[type + 'Summary'].find((d) => d.Id === collection.CollectionEntryId);
        if (routes) {
          let attribute = collection.BlueprintCollectionAttributes.find(x=> x.Name == 'route');
          let complexValue = this.dataUrlCommonService.getValidJsonValue(attribute.Value, attribute.Name);
          routes.SubCount += complexValue[attribute.Name].length;
        }
      }
      if(collection.CollectionName == 'NSG') {
        let nsg = this[type + 'Summary'].find((d) => d.Id === collection.CollectionEntryId);
        if (nsg) {
          let security_rule = collection.BlueprintCollectionAttributes.find(
            (x) => x.Name == 'security_rule'
          );
          if(security_rule) {
            security_rule
            let data = this.dataUrlCommonService.getValidJsonValue(
              security_rule.Value,
              security_rule.Name
            );
            nsg.SubCount += data[security_rule.Name].length;
          }
        }
      }
    }
    if (collection.BlueprintChildCollections && collection.BlueprintChildCollections.length) {
      collection.BlueprintChildCollections.forEach((child) => {
        this.getCollections(child, type);
      });
    }
  }

  getState(state: number, type: string = 'Source') {
    let stateObj = this.stateService.getState(state);
    this[type + 'Inventory']['StateForeColor'] = stateObj.ForeColor;
    this[type + 'Inventory']['StateColor'] = stateObj.Color;
    this[type + 'Inventory']['StateValue'] = stateObj.Value;
  }

  getResource(dependencyMapIds, type: string = 'Source') {
    this.dependencyMapService.getResourcesByDependencyMap(dependencyMapIds).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this[type + 'Summary'].forEach((sum) => {
        let data = res.find((resource) => resource.CollectionEntryId == sum.Id);
        if (data) {
          sum['ImagePath'] = data.ImagePath;
          sum['Description'] = data.Description;
        }
      });
      this.requestCompletedSummary = ++this.summaryCounter;
    });
  }

  getDefaultImage(event, cloudName) {
    let image = this.cloudConnectStateService.getImageByCloudKey(cloudName)
    event.target.src = image;
  }

  editors: any[] = [];
  editorInit(editor: MonacoStandaloneCodeEditor) {
    this.loadEditor = false;
    this.editors.push(editor);
    editor.setSelection({
      startLineNumber: 1,
      startColumn: 1,
      endColumn: 50,
      endLineNumber: 3
    });
  }
  onSelectTab(event) {
    this.selectedIndex = event;
    const treeViewTabIndex = 1;
    const configurationTabIndex = 2;

    if (this.selectedIndex == treeViewTabIndex) {
      this.isShowTreeView = true;
    }
    if (this.selectedIndex == configurationTabIndex && !this.isActiveConfiguartionTab) {
      this.isActiveConfiguartionTab = true;
      this.getTerraformCode(this.data.SourceInventoryId, 'Source');
      if(this.data.TargetInventory) {
        this.getTerraformCodeByObj(this.data.TargetInventory, 'Target');
      } else {
        this.getTerraformCode(this.data.TargetInventoryId, 'Target');
      }
    }
  }
}
